import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRICE } from '../data/content';
const includes = ['Guía de Autocuración Energética', 'Documento de orientación “Empezá acá”', 'Planificador de Autocuidado', 'Calendario Lunar', 'Limpieza Energética del Hogar', 'Diccionario de Cristales', 'Ritual de Protección', '50 Afirmaciones', 'Respirá en 5 Minutos', 'Diario de Bienestar de 30 Días'];
export function OfferSection() {
  return <section id="comprar" className="w-full scroll-mt-16 bg-cream px-5 py-12 sm:py-20" data-id="element-142" data-mp="mdig7xrvhf61">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-xl overflow-hidden rounded-[26px] border border-gold/40 bg-card shadow-[0_26px_60px_-34px_rgba(52,36,60,0.45)]" data-id="element-143" data-mp="rey560x685tp">
        <div className="bg-lavender px-6 py-5 text-center" data-id="element-144" data-mp="12ns378wk6iz6">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-aura" data-id="element-145" data-mp="12pcyx1um07ym">
            Todo incluido en un único acceso
          </p>
          <p className="mt-1 font-serif-display text-xl font-bold text-plum sm:text-2xl" data-id="element-146" data-mp="swxdfuk3t18z">
            Aura Viva 2026
          </p>
        </div>

        <div className="px-6 py-7 text-center sm:px-8" data-id="element-147" data-mp="ou0u21mqp13z">
          <span className="font-serif-display text-[52px] font-bold leading-none text-plum sm:text-6xl" data-id="element-148" data-mp="1llbe6i2kubo8">
            {PRICE}
          </span>
          <p className="mt-3 text-xs font-medium text-plum/75 sm:text-sm" data-id="element-149" data-mp="1gl6ukj6dh0ts">
            Pago único · Sin suscripción · Acceso de por vida
          </p>
          <p className="mt-1.5 text-xs font-semibold text-aura sm:text-sm" data-id="element-150" data-mp="17nejjr7oofc7">
            🇦🇷 Disponible actualmente en Argentina
          </p>

          <ul className="mt-6 grid gap-2.5 text-left sm:grid-cols-2" data-id="element-151" data-mp="14g6t6jjzhow">
            {includes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-152" data-mp="3sbizk2f1hw18">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/15 text-gold" data-id="element-153" data-mp="3tv154iymbb8k">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-154" data-mp="2mwzre6gw2ce" />
                </span>
                <span className="text-[13px] leading-relaxed text-plum/80" data-id="element-155" data-mp="3kt1lrk04rv2g">{item}</span>
              </li>)}
          </ul>

          <div className="mt-7" data-id="element-156" data-mp="3owr802tc20kb">
            <CTAButton label={`QUIERO ACCEDER POR ${PRICE}`} href={CHECKOUT_URL} textClassName="text-[14px] sm:text-[17px]" data-id="element-157" data-mp="3b300ezz5wqr8" />
            <p className="mt-3 text-xs text-plum/70 sm:text-sm" data-id="element-158" data-mp="3fv02oz2pfvqz">
              Acceso digital inmediato después de confirmar el pago.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}